export type MissionType = 'OVERAGE' | 'FIXED' | 'FULL_UNIT';
export type PeriodType = 'DAILY' | 'WEEKLY';
export type TargetType = 'ALL' | 'SPECIFIC';
export type MissionStatus = 'ACTIVE' | 'INACTIVE';

// TODO: 백엔드에 MISSION_TYPE 공통코드 그룹 등록 필요
// comCode=OVERAGE|FIXED|FULL_UNIT, comCdName=표시명, val1=설명, val2=보상 라벨, val3=보상 단위
export interface MissionTypeCode {
    code: MissionType;
    name: string;
    desc: string;
    rewardLabel: string;
    rewardUnit: string;
}

// TODO: 백엔드에 MISSION_PERIOD 공통코드 그룹 등록 필요
// comCode=DAILY|WEEKLY, comCdName=하루|일주일
export interface PeriodCode {
    code: PeriodType;
    name: string;
}

export interface MissionActualResult {
    totalAchievers: number;
    totalPayout: number;
    periodAchievers: number;
    periodPayout: number;
}

export interface Mission {
    id: number;
    seqNo: number;
    suppId: string;
    title: string;
    missionType: MissionType;
    period: PeriodType;
    targetCount: number;
    rewardAmount: number;
    maxCount: number;
    startDate: string;
    endDate: string;
    description: string;
    targetType: TargetType;
    targetRiders: string[];
    status: MissionStatus;
    actualResult?: MissionActualResult;
}

export interface FormState {
    missionType: MissionType;
    title: string;
    period: PeriodType;
    targetCount: string;
    rewardAmount: string;
    maxCount: string;
    startDate: string;
    endDate: string;
    description: string;
    targetType: TargetType;
    targetRiders: string[];
}

export interface EndedMissionAnalysis {
    isOneDay: boolean;
    totalTargets: string;
    totalPayout: string;
    dailyTargets: string;
    dailyPayout: string;
}

export const FALLBACK_MISSION_TYPE_CODES: MissionTypeCode[] = [
    {
        code: 'OVERAGE',
        name: '초과분 단가 지급',
        desc: '기간 동안 X건 이상 수행하면 X건을 초과한 1건당 Y원 지급',
        rewardLabel: '초과 1건당 지급',
        rewardUnit: '원/초과 1건',
    },
    {
        code: 'FIXED',
        name: '목표 달성 고정',
        desc: '기간 동안 X건 이상 수행하면 Y원 일시 지급',
        rewardLabel: '목표 달성 지급액',
        rewardUnit: '원',
    },
    {
        code: 'FULL_UNIT',
        name: '목표 달성 전체단가',
        desc: '기간 동안 X건 이상 달성 시, 그 기간 전체 건수 × Z원 지급',
        rewardLabel: '건당 단가',
        rewardUnit: '원/건',
    },
];

export const FALLBACK_PERIOD_CODES: PeriodCode[] = [
    { code: 'DAILY', name: '하루' },
    { code: 'WEEKLY', name: '일주일' },
];

export const STATUS_LABEL: Record<MissionStatus, string> = {
    ACTIVE: '활성',
    INACTIVE: '비활성',
};

export const DEFAULT_FORM: FormState = {
    missionType: 'OVERAGE',
    title: '',
    period: 'DAILY',
    targetCount: '',
    rewardAmount: '',
    maxCount: '',
    startDate: '',
    endDate: '',
    description: '',
    targetType: 'ALL',
    targetRiders: [],
};
